import { sum } from 'd3'
import { makeTargetChartOfAccountIds } from '../../../layout/statement-layout/make-target-chart-of-accounts-ids.js'
import { zenDb } from '../../index-values-db.js'
import { getDbProperty } from '../../value-property-to-use.js'

const DEBUG = false

export function computeFromMap (cellParams) {
  if (showDebug(cellParams)) {
    console.group('computeFromMap()')
    console.log('cellParams', cellParams)
  }

  const columnContext = cellParams.colDef.context

  const accountingOrganisationId = columnContext?.accountingOrganisation?.id

  const targetCurrencyCode = cellParams.context.currencySymbol === 'XXX' ? columnContext?.accountingOrganisation?.base_currency : cellParams.context.currencySymbol

  const targetChartOfAccountIds = makeTargetChartOfAccountIds(cellParams)

  const monthDate = columnContext.monthDate

  if (showDebug(cellParams)) {
    console.log('zenDb.map:', zenDb.map)
  }

  const allRelevantValues = []

  targetChartOfAccountIds?.forEach(function (targetChartOfAccountId) {
    const coaValues = zenDb.map
      ?.get(accountingOrganisationId)
      ?.get(targetCurrencyCode)
      ?.get(targetChartOfAccountId)
      ?.get(monthDate)

    if (showDebug(cellParams)) {
      console.log(`... accountingOrganisationId: .get(${accountingOrganisationId})`)
      console.log(zenDb.map.get(accountingOrganisationId))

      console.log(`... targetCurrencyCode: .get(${targetCurrencyCode})`)
      console.log(zenDb.map.get(accountingOrganisationId)?.get(targetCurrencyCode))

      console.log(`... targetChartOfAccountId: .get(${targetChartOfAccountId}) [Among ${targetChartOfAccountIds}]`)
      console.log(zenDb.map.get(accountingOrganisationId)?.get(targetCurrencyCode)?.get(targetChartOfAccountId))

      console.log(`... monthDate .get(${monthDate})`)
      console.log(zenDb.map.get(accountingOrganisationId)?.get(targetCurrencyCode)?.get(targetChartOfAccountId)?.get(monthDate))

      console.info('coaValues', coaValues)
    }

    if (!coaValues) return

    allRelevantValues.push(...coaValues)
  })
  if (showDebug(cellParams)) {
    console.log('allRelevantValues', allRelevantValues)
  }

  const dbProperty = getValueProperty(cellParams)

  const computedValue = sum(allRelevantValues, d => d[dbProperty])

  if (showDebug(cellParams)) {
    console.log('computedValue', computedValue)
  }
  if (showDebug(cellParams)) {
    console.groupEnd()
  }

  return computedValue
}

function showDebug (cellParams) {
  const showDebug = DEBUG || cellParams.context.showDebug
  return showDebug
}

function getValueProperty (cellParams) {
  if (cellParams.colDef.context.valueProperty) {
    return cellParams.colDef.context.valueProperty
  } else {
    const dbProperty = getDbProperty(cellParams.context.valueBalance)

    if (showDebug(cellParams)) {
      console.log('cellParams.colDef.context.valueProperty:', cellParams.colDef.context.valueProperty)
      console.log('dbProperty:', dbProperty)
    }
    return dbProperty
  }
}
